// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_kf-0";
export var animationContainer = "_kf-1";
export var itemPrice = "_kf-a";
export var itemizedContent = "_kf-9";
export var itemizedHeader = "_kf-7";
export var itemizedRow = "_kf-8";
export var itemizedSection = "_kf-6";
export var modalContent = "_kf-2";
export var orderName = "_kf-3";
export var refundOption = "_kf-4";
export var refundOptionsContainer = "_kf-5";
export var shippingLabel = "_kf-b";
export var totalRow = "_kf-c";